<template>
  <div class="article-tile">
    <router-link :to="routerLinkTo" v-touch="touchHandler">
      <div class="background-image"
        :data-orientation="imageAspect"
        ref="tileBgImage"
        :style="bgImageStyles"
      />
      <div class="tile-info">
        <div class="info-logo">
          <img class="logo-img"
            :src="clientLogoSrc"
          />
        </div>
        <div class="info-title"
          :style="infoTitleStyles"
          ref="infoTitle">
          {{ record.headline }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location

  see Work Article Tiles for supported aspect ratios
*/
import { Bus } from '@/helpers/bus';
import { Events } from '@/app-constants';
import { getResponsiveUrl } from '@/utils/image-utils';

import clients from '@/data/clients';

export default {

  props: ['record', 'colSpan', 'height', 'width'],

  data() {
    return {
      isTapped: false,
      handleBusTapEventFunc: null,
      titleHeight: 0,
    };
  },

  computed: {

    infoTitleStyles() {
      const { colSpan } = this;
      const styles = {};
      if (colSpan === 2) {
        styles.paddingRight = '130px';
        styles.marginRight = '226px';
      } else {
        styles.paddingRight = '26px';
        styles.marginRight = '0';
      }
      return styles;
    },

    imageData() {
      return this.record.image;
    },

    imageAspect() {
      const { image, colSpan } = this.record;
      return (colSpan === 2) ? 'landscape' : image.aspect;
    },

    logoStyles() {
      const logoSrc = this.clientLogoSrc;
      const styles = {
        src: `url(${logoSrc})`,
      };
      return styles;
    },

    clientLogoSrc() {
      const { client: clientKey } = this.record;
      const clientRec = clients[clientKey];
      const { logo } = clientRec;
      return logo;
    },


    bgImageStyles() {
      const { height, width, record } = this;
      const { image } = record;
      const { src, hAlign: hA, vAlign: vA } = image;

      // add defaults
      const hAlign = hA || 'center';
      const vAlign = vA || 'center';

      const maxDim = Math.max(width, height);
      const rUrl = getResponsiveUrl(src, maxDim);

      const styles = {
        backgroundImage: `url(${rUrl})`,
        backgroundPosition: `${hAlign} ${vAlign}`,
        height: `${this.height}px`,
      };
      return styles;
    },

    routerLinkTo() {
      const { url, data } = this.record;
      return {
        path: url,
        params: {
          url: url,
          data,
        },
      };
    },

  },

  methods: {

    measureLayout() {
      this.titleHeight = this.getTitleContentHeight();
    },

    getTitleContentHeight() {
      const el = this.$refs.infoTitle;
      return (el) ? el.clientHeight : 0;
    },

    // called from parent
    calculateTileAdjustment() {
      this.measureLayout();
      const { titleHeight } = this;

      /*
      // calculate the better offset
      // const offsets = [48, 34, 0];
      // const minHeight = 16; // picked by hand

      let height;
      let idx = 0;
      do {
        const offset = offsets[idx];
        height = titleHeight - offset;
        idx += 1;
      } while (height < minHeight);
      */
      const height = titleHeight - 28;
      return height;
    },

    touchHandler(e) {
      const { slug } = this.record;
      if (this.isTapped === true) {
        // double-tap: do default handling
        // console.warn(`double tap on ${slug}`);
      } else {
        // single-tap: show article content
        // console.warn(`single tap on ${slug}`);
        e.preventDefault();
        this.isTapped = true;
        Bus.$emit(Events.TappedArticle, slug);
      }
    },

  },

};
</script>


<style lang="scss" scoped>
@import '~@/styles/_typography.scss';
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

.article-tile {

  // fit to size of parent
  width: 100%;
  height: 100%;

  > a {
    display: block;
    color: $color--primary-dark;

    width: 100%;
    height: 100%;
  }

  .background-image {
    position: absolute;
    background-size: cover;
    background-position: center center;
    width: calc(100% - 26px);
    // height: caclulated above

    // transition: all 50ms; // 250ms
  }

  .tile-info {
    position: absolute;
    bottom: 0;
    margin-left: rem(28px);

    .info-logo {
      height: rem(48px);
      width: auto;

      // indent from side
      margin-left: rem(28px);

      // offset onto lower title
      position: relative;
      top: rem(19px);

      // make sure is above title
      z-index: 1;

      .logo-img {
        height: 100%;
        padding: 0 rem(16px);
        background-color: white;

      // transition: all 50ms; // 250ms
      }
    }

    .info-title {
      @include sansserif($size: (18, 30, 0), $weight: 'regular');
      margin: 0;
      background-color: white;

      // padding-right computed above
      padding: rem(16px) 0 rem(10px) rem(26px);
      max-width: 100%;

      // transition: all 50ms; // 250ms
    }
  }

    &:hover,
    &:active,
    &:focus,
    &.tapped {
      .background-image,
      .logo-img,
      .info-title {
        transform: scale(1.0125);
        box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.5);

        transition: all 250ms;
      }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/article-tile/ContentStaticTile.vue